import _ from 'lodash';
import { validateReduxForm } from 'common/form';
import { LogInteraction } from 'src/common/form/Interactions/components/LogInteraction';

const EDIT_INTERACTION_FORM = 'editInteractionNote';
const fields = [
  'interaction.is_note_private',
  'interaction.attached_to',
  'interaction.type',
  'interaction.occurred_on',
  'interaction.duration',
  'interaction.note',
  'caseOptions[].id',
  'caseOptions[].selected',
  'caseOptions[].label',
  'caseOptionSelected',
  'validateCases',
];

function mapStateToProps(state, ownProps = {}) {
  const { caseOptions = [] } = ownProps;
  const isMyProviderSensitive = _.get(state, 'globalState.currentProvider.group.sensitive', null);
  const validateCases = !_.isEmpty(caseOptions);
  const showNoteVisibility = ownProps.detailType === 'profile';

  return {
    durations: _.wget(state, 'session.enums.time.duration', []),
    initialValues: {
      caseOptions,
      interaction: ownProps.initialValues?.interaction,
      validateCases,
      ...ownProps.initialValues,
    },
    isMyProviderSensitive,
    showNoteVisibility,
  };
}

export default validateReduxForm({
  form: EDIT_INTERACTION_FORM,
  destroyOnUnmount: true,
  fields,
}, mapStateToProps)(LogInteraction);
